module.exports = __webpack_public_path__ + "static/media/dog.a9aace13.jpg";